import {
  CircularProgress,
  FormControl,
  IconButton,
  InputAdornment,
  InputLabel,
  MenuItem,
  Select,
} from '@mui/material';
import useAxiosPrivate from 'hooks/useAxiosPrivate';
import { memo, useState } from 'react';
import { useQuery } from 'react-query';
import { useSearchParams } from 'react-router-dom';

const ExpenseCategoryFilter = ({
  query = 'expense_category',
  label = 'Kategoriyasi',
  size = undefined,
  className,
  autoSelect,
  allowClear,
}) => {
  const axiosPrivate = useAxiosPrivate();
  const [hasError, setHasError] = useState(false);
  const [searchParams, setSearchParams] = useSearchParams();

  const { data, isLoading, isFetching } = useQuery({
    queryKey: '/dictionary/expense-category',
    queryFn: async function () {
      const response = await axiosPrivate.get('/dictionary/expense-category');
      return response.data.data;
    },
    onSuccess: (data) => {
      if (data && data.length > 0) {
        if (autoSelect && !searchParams.get(query)) {
          searchParams.set(query, data?.[0]?.id);
          setSearchParams(searchParams);
        }
      }
    },
    enabled: !hasError,
    onError: (error) => {
      setHasError(true);
    },
    retry: false,
  });

  const handleChange = (event) => {
    const {
      target: { value },
    } = event;
    searchParams.set(query, value);
    let localSearchParams = Object.fromEntries([...searchParams]);
    if (!isNaN(localSearchParams.page)) {
      searchParams.set('page', 1);
    }
    setSearchParams(searchParams);
  };

  const handleClearSelectBox = () => {
    searchParams.delete(query);
    setSearchParams(searchParams);
  };

  return (
    <FormControl fullWidth color='formColor'>
      <InputLabel id='single-block-filter-label'>{label}</InputLabel>
      <Select
        className={className}
        labelId='single-block-filter-label'
        id='single-block-filter-chip'
        label={label}
        value={searchParams.get(query) || ''}
        onChange={handleChange}
        color='formColor'
        variant='outlined'
        size={size}
        MenuProps={{
          id: 'single-block-filter-select-menu',
          PaperProps: {
            style: {
              maxHeight: 300,
            },
          },
          disableScrollLock: true,
        }}
        endAdornment={
          <InputAdornment position='end' className='custom-endAdornment'>
            {allowClear && searchParams.get(query) && (
              <IconButton
                onClick={() => handleClearSelectBox()}
                variant='onlyIcon'
                className='select-box-end-adornment-button'
              >
                <i className='bi bi-x end-adornment-close-button' />
              </IconButton>
            )}
          </InputAdornment>
        }
      >
        {isLoading || isFetching ? (
          <div className='circular-progress-box'>
            <CircularProgress size={25} />
          </div>
        ) : data && data.length > 0 ? (
          data.map((item, index) => (
            <MenuItem value={item.id} key={`block-${index + 1}`}>
              {item.name}
            </MenuItem>
          ))
        ) : (
          <div>
            <span className='no-data-found-wrapper select-box'>
              <i className='bi bi-exclamation-octagon text-lg mr-1' /> Ma'lumot
              topilmadi!
            </span>
          </div>
        )}
      </Select>
    </FormControl>
  );
};

export default memo(ExpenseCategoryFilter);
